import React, { Component } from 'react'
import { connect } from 'react-redux';
import {
    boxAction, box2Action, box3Action, box4Action, box5Action, box6Action
} from '../../../actions/settingsAction';
import AlertMessages from '../../common/AlertMessages';
import DeleteModal from '../../common/DeleteModal';
import EditModal from './elements/EditModal';
import ProjectCard from './elements/ProjectCard';
import { getService } from '../../../services/getService';
import authService from '../../Authentication/authService';
import BlankState from '../../common/BlankState';
import { validateFields } from '../../common/validations';
import ProjectCardSkeleton from '../../common/skeletons/ProjectCardSkeleton';
import { appendDataToFormData } from '../../../utils';
import Button from '../../common/formInputs/Button';
class ProjectList extends Component {
    constructor(props) {
        super(props);
        this.handleBox = this.handleBox.bind(this);
        this.state = {
            projectName: "",
            projectDescription: "",
            project_is_active: "",
            projectTechnology: "",
            profile_used: "",
            face_used: "",
            mobile_number_shared: "",
            address_shared: "",
            projects_shared: "",
            family_information_shared: "",
            teamMembers: [],
            projectStartDate: "",
            projectEndDate: "",
            successMessage: "",
            errorMessage: "",
            dropdownOpen: false,
            showSuccess: false,
            showError: false,
            employees: [],
            clients: [],
            projects: [],
            allProjects: '',
            selectedClient: "",
            logged_in_employee_id: null,
            logged_in_employee_role: null,
            searchQuery: "",
            statusFilter: "",
            errors: {},
            collapsedCards: {},
            editingProjectId: null,
            isEditing: false,
            showDeleteModal: false,
            deleteProjectId: null,
            deleteProjectName: '',
            isDeleting: false,
            showEditModal: false,
            isSubmitting: false,
        }
    }
    // Sort projects (active first, then inactive; each by date in decending order)
    sortProjects = (projects) => {
        const toTime = (p) => {
            const dateStr = p.created_at || p.project_start_date || p.updated_at || null;
            const t = dateStr ? Date.parse(dateStr) : 0;
            return isNaN(t) ? 0 : t;
        };
        const isActive = (p) => Number(p.project_is_active) === 1 ? 1 : 0;
        const copy = Array.isArray(projects) ? [...projects] : [];
        copy.sort((a, b) => {
            const aAct = isActive(a);
            const bAct = isActive(b);
            if (aAct !== bAct) return bAct - aAct; // active first
            return toTime(b) - toTime(a); // newer first
        });
        return copy;
    };
    handleBoxToggle = (index) => {
        this.setState((prevState) => ({
            collapsedCards: {
                ...prevState.collapsedCards,
                [index]: !prevState.collapsedCards[index], // toggle only the clicked card
            },
        }));
    };
    handleBox(e) {
        this.props.boxAction(e)
    }
    handleBox2(e) {
        this.props.box2Action(e)
    }
    handleBox3(e) {
        this.props.box3Action(e)
    }
    handleBox4(e) {
        this.props.box4Action(e)
    }
    handleBox5(e) {
        this.props.box5Action(e)
    }
    handleBox6(e) {
        this.props.box6Action(e)
    }

    componentDidMount() {
        this.setState({ loading: true });
        const { role } = window.user;
        if (window.user?.id) {
            this.setState({
                logged_in_employee_id: window.user.id,
                logged_in_employee_role: role
            });
        }

        // Fetch employees data
        // fetch(`${process.env.REACT_APP_API_URL}/get_employees.php?action=view&role=employee`, {
        //     method: "GET",
        // })
        getService.getCall('get_employees.php', {
            action: 'view',
            role: 'employee'
        })
            .then(data => {
                if (data.status === 'success') {
                    this.setState({
                        employees: data.status === 'success' ? data.data : [],
                        loading: false
                    });
                } else {
                    this.setState({ error: data.message, loading: false });
                }
            })
            .catch(err => {
                this.setState({ error: 'Failed to fetch employees data' });
                console.error(err);
            });


        // Get projects data
        getService.getCall('projects.php', {
            action: 'view',
            logged_in_employee_id: window.user.id,
            role: window.user.id
        })
            .then(data => {
                if (data.status === 'success') {
                    const collapsedCards = {};
                    data.data.forEach(project => {
                        collapsedCards[project.project_id] = Number(project.project_is_active) === 0;
                    });
                    this.setState({
                        projects: this.sortProjects(data.data),
                        allProjects: this.sortProjects(data.data),
                        loading: false
                    });
                } else {
                    this.setState({ error: data.message, loading: false });
                }
            })
            .catch(err => {
                this.setState({ error: 'Failed to fetch employees data' });
                console.error(err);
            });

        // Get clients data
        getService.getCall('clients.php', {
            action: 'view'
        })
            .then(data => {
                if (data.status === 'success') {
                    this.setState({
                        clients: data.status === 'success' ? data.data : [],
                        loading: false
                    });
                } else {
                    this.setState({ error: data.message, loading: false });
                }
            })
            .catch(err => {
                this.setState({ error: 'Failed to fetch employees data' });
                console.error(err);
            });
    }

    // Handle input changes
    handleInputChangeForAddProject = (event) => {
        const { name, value } = event.target;
        this.setState({
            [name]: value,
            errors: { ...this.state.errors, [name]: "" }
        });
    };

    handleSelectionChange = (event) => {
        const { name, multiple } = event.target;
        let value = multiple
            ? Array.from(event.target.selectedOptions, (option) => option.value) // Store as an array
            : event.target.value;

        this.setState((prevState) => ({
            [name]: value,
            errors: { ...prevState.errors, [name]: "" }
        }));
    };

    toggleDropdown = () => {
        this.setState((prevState) => ({
            dropdownOpen: !prevState.dropdownOpen,
        }));
    };

    handleCheckboxChange = (event) => {
        const { value, checked } = event.target;

        this.setState((prevState) => {
            let updatedTeamMembers = [...prevState.teamMembers];

            if (checked) {
                // Add employee ID if checked
                updatedTeamMembers.push(value);
            } else {
                // Remove employee ID if unchecked
                updatedTeamMembers = updatedTeamMembers.filter((id) => id !== value);
            }

            return { teamMembers: updatedTeamMembers };
        });
    };

    // Validate Add Project Form
    validateAddProjectForm = (e) => {
        const { projectName, projectDescription, projectTechnology, teamMembers, projectStartDate, projectEndDate } = this.state;

        // Apply Validation component
        const validationSchema = [
            { name: 'projectName', value: projectName, type: 'name', required: true, messageName: 'Project Name' },
            { name: 'projectDescription', value: projectDescription, required: true, minLength: 10, messageName: 'Project Description' },
            { name: 'projectTechnology', value: projectTechnology, required: true, messageName: 'Project Technology', },
            {
                name: 'teamMembers',
                value: teamMembers,
                required: true,
                messageName: 'Team Members',
                customValidator: (val) => {
                    if (!val || (Array.isArray(val) && val.length === 0)) {
                        return "Please assign at least one team member.";
                    }
                    return undefined;
                }
            },
            {
                name: 'projectStartDate',
                value: projectStartDate,
                type: 'date',
                required: true,
                messageName: 'Project Start Date'
            },
            {
                name: 'projectEndDate',
                value: projectEndDate,
                required: false,
                customValidator: (val) => {
                    if (projectStartDate && val && new Date(val) < new Date(projectStartDate)) {
                        return "Project End Date must be after the Start Date.";
                    }
                    return undefined;
                }
            }
        ];
        const errors = validateFields(validationSchema);

        this.setState({ errors });
        return Object.keys(errors).length === 0;
    };

    getEmployeeName = (employeeId, namePart) => {
        const employee = this.state.employees.find(emp => String(emp.id) === String(employeeId));
        if (!employee) return '';
        return namePart === 'first' ? employee.first_name : employee.last_name;
    };

    // Add/Update project data API call
    addProjectData = () => {
        const {
            logged_in_employee_id,
            projectName,
            projectDescription,
            projectTechnology,
            profile_used,
            face_used,
            mobile_number_shared,
            address_shared,
            projects_shared,
            family_information_shared,
            projectStartDate,
            projectEndDate,
            selectedClient,
            teamMembers,
            isEditing,
            editingProjectId,
            project_is_active
        } = this.state;

        if (!this.validateAddProjectForm()) {
            return; // Stop execution if validation fails
        }

        const projectFormData = new FormData();
        // projectFormData.append('logged_in_employee_id', logged_in_employee_id);
        // projectFormData.append('project_name', projectName);
        // projectFormData.append('project_description', projectDescription);
        // projectFormData.append('project_technology', projectTechnology);
        // projectFormData.append('client_id', selectedClient);
        // projectFormData.append('project_start_date', projectStartDate);
        // projectFormData.append('project_end_date', projectEndDate);

        const data = {
            logged_in_employee_id: logged_in_employee_id,
            project_name: projectName,
            project_description: projectDescription,
            project_technology: projectTechnology,
            profile_used: profile_used,
            face_used: face_used,
            mobile_number_shared: mobile_number_shared,
            address_shared: address_shared,
            projects_shared: projects_shared,
            family_information_shared: family_information_shared,
            client_id: selectedClient,
            project_start_date: projectStartDate,
            project_end_date: projectEndDate,
        }
        appendDataToFormData(projectFormData, data)

        teamMembers.forEach((member) => {
            projectFormData.append('team_members[]', member);
        });
        if (isEditing && editingProjectId) {
            projectFormData.append('project_id', editingProjectId);
        }

        const successMessage = isEditing ? 'Project updated successfully!' : 'Project added successfully!';

        const apiCall = isEditing
            ? getService.editCall('projects.php', 'edit', projectFormData, null, editingProjectId)
            : getService.addCall('projects.php', 'add', projectFormData);

        apiCall.then((data) => {
            if (data.status === 'success' || data.success) {
                // Refresh the project list from the backend instead of updating state manually
                this.fetchProjects();

                this.setState({
                    projectName: "",
                    projectDescription: "",
                    projectTechnology: "",
                    profile_used: "",
                    face_used: "",
                    mobile_number_shared: "",
                    address_shared: "",
                    projects_shared: "",
                    family_information_shared: "",
                    selectedClient: "",
                    teamMembers: [],
                    projectStartDate: "",
                    projectEndDate: "",
                    errors: {},
                    editingProjectId: null,
                    isEditing: false,
                    showEditModal: false,
                    isSubmitting: false,
                    successMessage: successMessage,
                    showSuccess: true,
                });
                setTimeout(this.dismissMessages, 3000);
            } else {
                this.setState({
                    errorMessage: data.message || `Failed to ${isEditing ? 'update' : 'add'} project. Please try again.`,
                    showError: true,
                    isSubmitting: false,
                });
                setTimeout(this.dismissMessages, 3000);
            }
        })
            .catch((error) => {
                console.error("Error:", error);
                this.setState({
                    errorMessage: `An error occurred while ${isEditing ? 'editting' : 'adding'} the project.`,
                    showError: true,
                    isSubmitting: false,
                });
                setTimeout(this.dismissMessages, 3000);
            });
    };

    // Reset form errors when modal is closed
    resetFormErrors = () => {
        this.setState({
            errors: {}, // Clear all error messages
            projectName: "",
            projectDescription: "",
            projectTechnology: "",
            profile_used: "",
            face_used: "",
            mobile_number_shared: "",
            address_shared: "",
            projects_shared: "",
            family_information_shared: "",
            selectedClient: "",
            teamMembers: [],
            projectStartDate: "",
            projectEndDate: "",
            editingProjectId: null,
            isEditing: false,
        });

        // Properly close the modal
        const modal = document.querySelector("#addProjectModal");
        if (modal) {
            modal.classList.remove('show');
            modal.style.display = 'none';
            document.body.classList.remove('modal-open');

            // Remove backdrop
            const backdrop = document.getElementById('modalBackdrop');
            if (backdrop) {
                backdrop.remove();
            }
        }
    };

    // Function to dismiss messages
    dismissMessages = () => {
        this.setState({
            showSuccess: false,
            successMessage: "",
            showError: false,
            errorMessage: "",
        });
    };

    // API for Toggle o and 1

    handleToggleProjectStatus = async (projectId, currentStatus) => {
        const newStatus = Number(currentStatus) === 1 ? 0 : 1; // Toggle between 1 and 0
        const user = authService.getUser();
        const token = user ? user.access_token : null;

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/projects.php?action=update_active_status`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
                },
                body: JSON.stringify({
                    id: projectId,
                    is_active: newStatus,
                    logged_in_employee_id: this.state.logged_in_employee_id
                })
            });

            const data = await response.json();

            if (data.status === 'success') {
                this.fetchProjects();

                this.setState({
                    showSuccess: true,
                    successMessage: `Project ${newStatus === 1 ? 'activated' : 'deactivated'}!`
                });

                // Auto-dismiss success message after 3 seconds
                setTimeout(this.dismissMessages, 3000);
            } else {
                // Error handling
                this.setState({
                    showError: true,
                    errorMessage: data.message || 'Failed to update project status.'
                });

                setTimeout(this.dismissMessages, 3000);
            }
        } catch (error) {
            // Error handling
            this.setState({
                showError: true,
                errorMessage: 'Failed to update project status.'
            });

            // Auto-dismiss error message after 3 seconds
            setTimeout(this.dismissMessages, 3000);
        }
    };
    // Add searching functionality for project search (API-based, name and technology, debounced)
    handleSearch = (event) => {
        const query = event.target.value;
        this.setState({ searchQuery: query });

        // Clear previous timeout
        if (this.searchTimeout) clearTimeout(this.searchTimeout);

        this.searchTimeout = setTimeout(() => {
            this.fetchProjects();
        }, 500);
    };

    handleStatusFilterChange = (event) => {
        const status = event.target.value;
        this.setState({ statusFilter: status }, this.fetchProjects);
    };

    fetchProjects = () => {
        const { searchQuery, statusFilter } = this.state;
        const searchParam = searchQuery.trim();

        const params = {
            action: 'view',
            logged_in_employee_id: window.user.id,
            role: window.user.role
        };

        if (searchParam !== "") params.search = searchParam;
        if (statusFilter !== "") params.status = statusFilter;

        getService.getCall('projects.php', params)
            .then(data => {
                if (data.status === 'success') {
                    this.setState({
                        projects: this.sortProjects(data.data),
                        allProjects: this.sortProjects(data.data),
                    });
                } else {
                    this.setState({ projects: [], allProjects: [] });
                }
            })
            .catch(err => {
                this.setState({ projects: [], allProjects: [] });
                console.error(err);
            });
    };

    handleEditProject = (project) => {
        const teamMemberIds = project.team_members
            ? project.team_members.map(member => String(member.employee_id || member.id))
            : [];

        this.setState({
            projectName: project.project_name || "",
            projectDescription: project.project_description || "",
            projectTechnology: project.project_technology || "",
            profile_used: project.profile_used || "",
            face_used: project.face_used || "",
            mobile_number_shared: project.mobile_number_shared || "",
            address_shared: project.address_shared || "",
            projects_shared: project.projects_shared || "",
            family_information_shared: project.family_information_shared || "",
            selectedClient: project.client_id || "",
            teamMembers: teamMemberIds,
            projectStartDate: project.project_start_date || "",
            projectEndDate: project.project_end_date || "",
            editingProjectId: project.project_id,
            isEditing: true,
            showEditModal: true,
            dropdownOpen: false
        });
    };

    // Handle delete project - show delete modal
    handleDeleteProject = (projectId, projectName) => {
        this.setState({
            showDeleteModal: true,
            deleteProjectId: projectId,
            deleteProjectName: projectName
        });
    };

    confirmDeleteProject = () => {
        const { deleteProjectId } = this.state;
        if (!deleteProjectId) return;

        this.setState({ ButtonLoading: true, isDeleting: true });

        getService.deleteCall('projects.php', 'delete', deleteProjectId, null, null, null)
            .then(data => {
                if (data.status === 'success' || data.success) {
                    this.setState(prevState => ({
                        projects: prevState.projects.filter(project => project.project_id !== deleteProjectId),
                        allProjects: prevState.allProjects.filter(project => project.project_id !== deleteProjectId),
                        showSuccess: true,
                        successMessage: 'Project deleted successfully!',
                        showDeleteModal: false,
                        deleteProjectId: null,
                        deleteProjectName: '',
                        isDeleting: false
                    }));

                    setTimeout(this.dismissMessages, 3000);
                } else {
                    // Error handling remains the same
                    this.setState({
                        showError: true,
                        errorMessage: data.message || 'Failed to delete project',
                        showDeleteModal: false,
                        deleteProjectId: null,
                        deleteProjectName: '',
                        isDeleting: false
                    });
                    setTimeout(this.dismissMessages, 3000);
                }
            })
            .catch(error => {
                console.error('Error deleting project:', error);
                this.setState({
                    showError: true,
                    errorMessage: 'An error occurred while deleting the project',
                    showDeleteModal: false,
                    deleteProjectId: null,
                    deleteProjectName: '',
                    isDeleting: false
                });
                setTimeout(this.dismissMessages, 3000);
            });
    };

    // Close delete modal
    closeDeleteModal = () => {
        this.setState({
            showDeleteModal: false,
            deleteProjectId: null,
            deleteProjectName: '',
            isDeleting: false
        });
    };

    // Close edit modal
    closeEditModal = () => {
        this.setState({
            showEditModal: false,
            editingProjectId: null,
            isEditing: false,
            projectName: "",
            projectDescription: "",
            projectTechnology: "",
            profile_used: "",
            face_used: "",
            mobile_number_shared: "",
            address_shared: "",
            projects_shared: "",
            family_information_shared: "",
            selectedClient: "",
            teamMembers: [],
            projectStartDate: "",
            projectEndDate: "",
            errors: {},
            dropdownOpen: false
        });
    };

    // Handle edit modal submit
    handleEditModalSubmit = () => {
        this.setState({ isSubmitting: true });
        this.addProjectData();
    };

    // Show delete modal
    showDeleteModal = () => {
        const modal = document.querySelector('#deleteProjectModal');
        if (modal) {
            modal.classList.add('show');
            modal.style.display = 'block';
            document.body.classList.add('modal-open');
        }
    };

    // Hide delete modal
    hideDeleteModal = () => {
        const modal = document.querySelector('#deleteProjectModal');
        if (modal) {
            modal.classList.remove('show');
            modal.style.display = 'none';
            document.body.classList.remove('modal-open');
        }
    };


    render() {
        const { fixNavbar/* , boxOpen */ } = this.props;
        const { projects, message, logged_in_employee_role, showSuccess, successMessage, showError, errorMessage } = this.state;

        // Filter projects for employees: only show active projects
        const visibleProjects = (logged_in_employee_role === 'admin' || logged_in_employee_role === 'super_admin')
            ? projects
            : projects.filter(project => Number(project.project_is_active) === 1)
                .sort((a, b) => (Date.parse(b.created_at || b.project_start_date || 0) || 0) - (Date.parse(a.created_at || a.project_start_date || 0) || 0));
        const skeletonCount = visibleProjects.length === 0 ? 6 : visibleProjects.length;

        return (
            <>
                <AlertMessages
                    showSuccess={showSuccess}
                    successMessage={successMessage}
                    showError={showError}
                    errorMessage={errorMessage}
                    setShowSuccess={(val) => this.setState({ showSuccess: val })}
                    setShowError={(val) => this.setState({ showError: val })}
                />
                <div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
                    <div className="container-fluid">
                        <div className="d-flex justify-content-between align-items-center mt-2">
                            <ul className="nav nav-tabs page-header-tab">
                                {/* <li className="nav-item"><a className="nav-link active" id="Project-tab" data-toggle="tab" href="#Project-OnGoing">OnGoing</a></li> */}
                            </ul>
                            <div className="header-action d-md-flex">
                                <div className="input-group mr-2">
                                    <select
                                        className="form-control"
                                        value={this.state.statusFilter}
                                        onChange={this.handleStatusFilterChange}
                                    >
                                        <option value="">All</option>
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                </div>
                                <div className="input-group mr-2">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search project..."
                                        name="s"
                                        value={this.state.searchQuery}
                                        onChange={this.handleSearch}
                                    />
                                </div>
                                {(logged_in_employee_role === 'admin' || logged_in_employee_role === 'super_admin') && (
                                    <Button
                                        label="Add"
                                        onClick={() => this.setState({
                                            showEditModal: true,
                                            isEditing: false,
                                            projectName: "",
                                            projectDescription: "",
                                            projectTechnology: "",
                                            profile_used: "",
                                            face_used: "",
                                            mobile_number_shared: "",
                                            address_shared: "",
                                            projects_shared: "",
                                            family_information_shared: "",
                                            selectedClient: "",
                                            teamMembers: [],
                                            projectStartDate: "",
                                            projectEndDate: "",
                                            errors: {},
                                            dropdownOpen: false
                                        })}
                                        className="btn-primary"
                                        icon="fe fe-plus mr-2"
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section-body mt-3">
                    <div className="container-fluid">
                        <div className="tab-content">
                            <div className="tab-pane fade show active" id="Project-OnGoing" role="tabpanel">
                                <div className="row">
                                    {this.state.loading ? (
                                        Array.from({ length: skeletonCount }).map((_, index) => (
                                            <ProjectCardSkeleton key={index} />
                                        ))
                                    ) : visibleProjects && visibleProjects.length > 0 ? (
                                        visibleProjects.map((project, index) => (
                                            <ProjectCard
                                                key={index}
                                                project={project}
                                                index={index}
                                                logged_in_employee_role={logged_in_employee_role}
                                                onToggleStatus={this.handleToggleProjectStatus}
                                                onEdit={this.handleEditProject}
                                                onDelete={this.handleDeleteProject}
                                                collapsedCards={this.state.collapsedCards}
                                            />
                                        ))
                                    ) : (
                                        !message && (
                                            <div className="col-12">
                                                <BlankState message="Projects not available" />
                                            </div>
                                        )
                                    )}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {/* Edit/Add Project Modal */}
                <EditModal
                    modalId="editProjectModal"
                    isOpen={this.state.showEditModal}
                    onClose={this.closeEditModal}
                    onSubmit={this.handleEditModalSubmit}
                    formData={{
                        projectName: this.state.projectName,
                        projectDescription: this.state.projectDescription,
                        projectTechnology: this.state.projectTechnology,
                        profile_used: this.state.profile_used,
                        face_used: this.state.face_used,
                        mobile_number_shared: this.state.mobile_number_shared,
                        address_shared: this.state.address_shared,
                        projects_shared: this.state.projects_shared,
                        family_information_shared: this.state.family_information_shared,
                        selectedClient: this.state.selectedClient,
                        teamMembers: this.state.teamMembers,
                        projectStartDate: this.state.projectStartDate,
                        projectEndDate: this.state.projectEndDate
                    }}
                    onInputChange={this.handleInputChangeForAddProject}
                    onSelectionChange={this.handleSelectionChange}
                    onCheckboxChange={this.handleCheckboxChange}
                    errors={this.state.errors}
                    employees={this.state.employees}
                    clients={this.state.clients}
                    dropdownOpen={this.state.dropdownOpen}
                    toggleDropdown={this.toggleDropdown}
                    isEditing={this.state.isEditing}
                    isLoading={this.state.isSubmitting}
                />

                {/* Delete Project Modal */}
                <DeleteModal
                    show={this.state.showDeleteModal}
                    modalId="deleteProjectModal"
                    deleteBody={`Are you sure you want to delete the project "${this.state.deleteProjectName}"`}
                    onConfirm={this.confirmDeleteProject}
                    onClose={() => this.setState({ showDeleteModal: false, selectedId: null })}
                    isLoading={this.state.isDeleting}
                />
            </>
        )
    }
}
const mapStateToProps = state => ({
    fixNavbar: state.settings.isFixNavbar,
    boxOpen: state.settings.isbox,
    box2Open: state.settings.isbox2,
    box3Open: state.settings.isbox3,
    box4Open: state.settings.isbox4,
    box5Open: state.settings.isbox5,
    box6Open: state.settings.isbox6,
})

const mapDispatchToProps = dispatch => ({
    boxAction: (e) => dispatch(boxAction(e)),
    box2Action: (e) => dispatch(box2Action(e)),
    box3Action: (e) => dispatch(box3Action(e)),
    box4Action: (e) => dispatch(box4Action(e)),
    box5Action: (e) => dispatch(box5Action(e)),
    box6Action: (e) => dispatch(box6Action(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(ProjectList);